
























import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { getPrescriptionProducts } from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages
  }
})
export default class ProductsPrescriptionList extends BaseComponent {
  @Prop()
  public id;

  @Prop()
  public idSipro;

  menu: any = false;
  loading = false;
  produtos: any[] = [];
  menuKey = 1;

  @Watch('menu')
  onMenuChange(v) {
    if (this.loading || this.produtos.length) {
      return;
    }

    this.load();
  }

  load() {
    this.loading = true;
    getPrescriptionProducts(this.id).subscribe(
      (res) => {
        this.produtos = res;
        this.loading = false;
        this.menuKey++;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }
}
